<template>
  <div class="dayunshan-articles-container">
    <div class="page-header">
      <div class="back-button" @click="goBack">
        <van-icon name="arrow-left" size="20" />
      </div>
      <h1 class="page-title">大云山荞麦基地</h1>
    </div>

    <!-- 图片 -->
    <div class="banner-image">
      <my-img url="https://cdn.keihong.tech/img/20250518144257829.png" style="width: 100%;"/>
    </div>

    <div class="page-content">
      <div class="intro-text">
        <!-- 大云山国家森林公园位于湖南省岳阳县，是国家AAAA级旅游景区。这里山峦起伏，林木葱郁，景色宜人。以下是公园的景点介绍： -->
         荞麦叶科普
      </div>

      <!-- 文章列表 -->
      <div class="article-list">
        <van-cell
          v-for="article in articles"
          :key="article.id"
          :title="article.title"
          is-link
          @click="goToArticleDetail(article.id)"
          class="article-item"
        >
          <template #label>
            <span class="article-desc">{{ article.description }}</span>
          </template>
        </van-cell>
      </div>
    </div>
  </div>
</template>

<script>
import { Cell, Icon } from 'vant'
import MyImg from '@/h5/doucan/components/MyImg.vue'
export default {
  name: 'DayunshanArticles',
  components: {
    'van-cell': Cell,
    'van-icon': Icon,
    MyImg
  },
  data () {
    return {
      articles: [
        {
          id: 'dayunshan_102',
          title: '1. 大云山荞麦如何 "通关"',
          description: '气候、海拔与土壤三重考验下，大云山荞麦如何 "通关"'
        },
        {
          id: 'dayunshan_109',
          title: '2. 大云山苦荞叶的种植',
          description: '大云山苦荞叶的种植'
        },
        {
          id: 'dayunshan_103',
          title: '3. 荞麦叶的功效、作用',
          description: '荞麦叶性寒，在中医理论中归肝、胆、胃经。具有清热解毒、凉血止血功效。可用于治疗感冒发热、咳嗽等症状；《千金要方》也提及芥麦叶能应对温热引发的出血症状，这些记载为后研究与应用提供了重要依据。'
        },
        {
          id: 'dayunshan_104',
          title: '4. 苦荞麦—糖尿病的克星',
          description: '苦荞麦中含有的芦丁、槲皮素、硒等成分，具有降血糖、降血脂、降血压的功效。'
        },
        {
          id: 'dayunshan_105',
          title: '5. 换一款主食，控血压还能稳血糖！',
          description: '换一款主食，控血压还能稳血糖！'
        },
        {
          id: 'dayunshan_106',
          title: '6. 就冲这5点，所有人都该多把荞麦当主食！',
          description: '就冲这5点，所有人都该多把荞麦当主食！'
        },
        {
          id: 'dayunshan_107',
          title: '7. 荞麦有4000年种植历史，荞麦叶究竟有何独特价值？',
          description: '荞麦有4000年种植历史，荞麦叶究竟有何独特价值？'
        },
        {
          id: 'dayunshan_108',
          title: '8. 天然的 "酸菜"—— 荞麦叶：解锁 N 种神仙吃法',
          description: '天然的 "酸菜"—— 荞麦叶：解锁 N 种神仙吃法'
        }
      ]
    }
  },
  methods: {
    // 返回上一页
    goBack () {
      this.$router.back()
    },
    // 跳转到文章详情页
    goToArticleDetail (id) {
      this.$router.push({
        path: '/article/detail',
        query: { id }
      })
    }
  }
}
</script>

<style scoped>
.dayunshan-articles-container {
  padding: 8px;
  min-height: 100vh;
  background-color: #f7f8fa;
}

.page-header {
  position: relative;
  margin-bottom: 24px;
  padding-top: 10px;
  text-align: center;
}

.back-button {
  position: absolute;
  top: 10px;
  left: 0;
  width: 36px;
  height: 36px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.page-title {
  font-size: 20px;
  font-weight: bold;
  color: #323233;
}

.page-content {
  background-color: #fff;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 2px 12px rgba(100, 101, 102, 0.08);
}

.intro-text {
  margin-bottom: 24px;
  line-height: 1.6;
  font-size: 1.3em;
  font-weight: bold;
  color: #323233;
  text-align: justify;
  padding: 16px;
}

.article-list {
  margin-top: 8px;
  padding: 0 0;
}

.article-item {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  font-size: 1.3em;
}

.article-desc {
  font-size: 1.3em;
  color: #646566;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}
</style>
